/*
    描述 ：存放基础平台用到的枚举编码KEY
    创建 ：袁俊双 2019-07-16
    更新记录 ：
    1、增加水印上传策略 by wangyz on 2019-07-25 16:11:32
    2、增加任务调度和页面打开方式枚举 by wangyz on 2019-07-26 18:54:17
*/

export class BdpEnum{
    
    //region  文件策略枚举区
    static SYS_WATERIMG = "SYS_WATERIMG";   //水印上传策略
    // endregion
    static SYS_LCTYPE_OPTION ="SYS_LCTYPE_OPTION";  

    //region 系统参数配置枚举区
    static FILE_TYPE_LIMIT = "FILE_TYPE_LIMIT";
    //endregion


    //region 字典下拉枚举区
    static SYS_OPENTYPE_OPTION = "SYS_OPENTYPE_OPTION";        //系统页面打开方式
    static SYS_BTN_OPENTYPE_OPTION = "SYS_BTN_OPENTYPE_OPTION";        //系统按钮打开方式
    static SYS_SCHEDULE_CLIENT_OPTION = "SYS_SCHEDULE_CLIENT_OPTION"; //任务调度客户端类名
    static SYS_CODE_OPTION = "SYS_CODE_OPTION"; //基础通用 系统API
    //endregion

    //region 流程操作状态
    static SYS_PROCESS_ADD = "processAdd"; // 流程发起(发起)
    static SYS_PROCESS_UPDATE = "processUpdate"; // 流程编辑(待发)
    static SYS_PROCESS_VERIFY = "processVerify"; // 流程审核(待办)
    static SYS_PROCESS_VIEW = "processView"; // 流程查看(已办/已发/消息/查询）
    //endregion 流程操作状态

    //region  全文检索datas专区
    static ES_CMS_CLUSTERNAME = "cms";
    static ES_CKF_CLUSTERNAME = "ckf";
    static ES_MENU_CLUSTERNAME = "menu";
    static ES_FILE_CLUSTERNAME = "file";

    static ES_CMS_SEARCHMAP_EXHIBITION = { "type": "exhibition" }; //cms模块的资讯检索
    static ES_CMS_SEARCHMAP_ACTIVITY = { "type": "activity" };//cms模块的展览检索
    static ES_CMS_SEARCHMAP_ARCHIVES = { "type": "archives" };  //cms模块的活动检索

    static ES_CKF_SEARCHMAP_COLLECTION = { "type": "collection" };   //ckf藏品

    static ES_MENU_SEARCHMAP = { "type": "menu" };   //菜单
    static ES_FILE_SEARCHMAP = { "type": "file" };   //文件
    // endregion

    //#region 
    static SYS_WIDGET_TYPE_OPTION = "SYS_WIDGET_TYPE_OPTION";   //工作台组件类型
    //#endregion
    
    //#region 
    //完整的富文本工具栏
    static ALL_TOOLBAR = [
        'fullscreen', 'source', '|', 'undo', 'redo', '|',
        'bold', 'italic', 'underline', 'fontborder', 'strikethrough', 'superscript', 'subscript', 'removeformat', 'formatmatch', 'autotypeset', 'blockquote', 'pasteplain', '|', 'forecolor', 'backcolor', 'insertorderedlist', 'insertunorderedlist', 'selectall', 'cleardoc', '|',
        'rowspacingtop', 'rowspacingbottom', 'lineheight', '|',
        'customstyle', 'paragraph', 'fontfamily', 'fontsize', '|',
        'directionalityltr', 'directionalityrtl', 'indent', '|',
        'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|', 'touppercase', 'tolowercase', '|',
        'link', 'unlink', 'anchor', '|', 'imagenone', 'imageleft', 'imageright', 'imagecenter', '|',
        'insertimage', 'emotion', 'insertvideo', 'music', 'attachment', 'map', 'insertframe', 'pagebreak', 'template', '|',
        'horizontal', 'date', 'time', 'spechars', '|',
        'inserttable', 'deletetable', 'insertparagraphbeforetable', 'insertrow', 'deleterow', 'insertcol', 'deletecol', 'mergecells', 'mergeright', 'mergedown', 'splittocells', 'splittorows', 'splittocols', '|',
        'print', 'preview', 'searchreplace'
    ]
    //简化的富文本工具栏
    static SIMPLIFY_TOOL_BAR = [
        'source', '|', 'undo', 'redo', '|',
        'bold', 'italic', 'underline', 'fontborder', 'strikethrough', 'superscript', 'subscript', 'removeformat', 'formatmatch',
        'autotypeset', 'blockquote', 'pasteplain', '|', 'forecolor', 'backcolor', 'selectall', 'cleardoc', '|',
        'rowspacingtop', 'rowspacingbottom', 'lineheight', '|',
        'customstyle', 'paragraph', 'fontfamily', 'fontsize', '|',
        'directionalityltr', 'directionalityrtl', 'indent', '|',
        'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify'
    ]
    //#endregion
}